export const useAppStore = defineStore("app", () => {
  // States

  const teleport = ref("body");

  return {
    teleport,
  };
});
